import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'gains-tiles',
  standalone: false,
  templateUrl: './gains-tiles.component.html',
  styleUrl: './gains-tiles.component.scss'
})
export class GainsTilesComponent {
  @Output() onclick = new EventEmitter<void>();
  @Input() icon?: string;
  @Input() title?: string;
  @Input() content?: string;
  @Input() routerLink?: string | any[];
  @Input() isDisabled = false;
  @Input() showFooter = true;
  @Input() showFooterDivider = true;
  @Input() showStatus = true;
  @Input() statusText?: string;
  @Input() statusState?: 'active' | 'inactive';
  @Input() activatedRoute!: ActivatedRoute;

  constructor(private router: Router) {}

  get statusLabel(): string {
    return this.statusText ?? (this.isDisabled ? 'Disabled' : 'Active');
  }

  get isStatusInactive(): boolean {
    if (this.statusState) {
      return this.statusState === 'inactive';
    }

    return this.isDisabled;
  }

  handleClick() {
    if (this.isDisabled) return;
    this.onclick.emit();
  }
}
